"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const SpanStyled = _styledComponents.default.span.withConfig({
  displayName: "Percentage__SpanStyled",
  componentId: "design-system__sc-1kw7xpi-0"
})(["font-family:", ";font-size:", ";color:", ";"], _BaseTheme.default.type.family.content, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.black);

const Percentage = _ref => {
  let {
    value,
    minDecimals
  } = _ref;
  const result = "".concat((value * 100).toFixed(minDecimals), "%");
  return /*#__PURE__*/_react.default.createElement(SpanStyled, null, result);
};

Percentage.propTypes = {
  value: _propTypes.default.number.isRequired,
  minDecimals: _propTypes.default.number
};
Percentage.defaultProps = {
  minDecimals: 2
};
var _default = Percentage;
exports.default = _default;